/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TravelInsuranceCompleteInfoRequestDto } from '../models/travel-insurance-complete-info-request-dto';

@Injectable({
  providedIn: 'root',
})
export class TravelInsuranceRequestCompleteInfoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation apiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPost
   */
  static readonly ApiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPostPath = '/quoter/SetCompleteInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPost$Response(params: {
    body?: TravelInsuranceCompleteInfoRequestDto;
  }): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TravelInsuranceRequestCompleteInfoService.ApiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPostPath,
      'put'
    );
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPost(params: {
    body?: TravelInsuranceCompleteInfoRequestDto;
  }): Observable<void> {
    return this.apiServicesAppTravelInsuranceRequestCompleteInfoCompleteInfoPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }
}
